import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { SELF_DEFENSE_RELATED_LINKS } from './selfDefenseContent';
export function SelfDefenseRelatedLinks() {
  return <section className="py-20 bg-off-white border-t border-subtle-gray" data-id="element-3015">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3016">
        <h2 className="text-3xl md:text-4xl text-ink text-center mb-12" data-id="element-3017">
          Related Classes & Programs
        </h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-3018">
          {SELF_DEFENSE_RELATED_LINKS.map(link => <Link key={link.href} to={link.href} className="group bg-paper border border-subtle-gray hover:border-storm-red rounded-2xl p-6 transition-all flex items-start justify-between gap-4" data-id="element-3019">
              <div data-id="element-3020">
                <p className="font-bold text-ink text-lg mb-1" data-id="element-3021">{link.title}</p>
                {link.description && <p className="text-sm text-gray-warm" data-id="element-3022">{link.description}</p>}
              </div>
              <ArrowRight className="w-5 h-5 text-storm-red shrink-0 mt-1 group-hover:translate-x-1 transition-transform" data-id="element-3023" />
            </Link>)}
        </div>
      </div>
    </section>;
}